import React from "react";
import Tabs from '../Tabs/Tabs';
import AdditionalCustomerFieldPresenterWorkspace from "./AdditionalCustomerFieldPresenterWorkspace";

export default class AdditionalCustomerFieldPresenter extends React.Component {
  
  constructor(props){
    super(props)

    this.state = {
      active_tab: 'general'
    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
  }

  render() {
    return (
      <div className="AdditionalCustomerFieldPresenter">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <AdditionalCustomerFieldPresenterWorkspace
            {...this.props}
            {...this.state} />  
        </div>
      </div>
    );
  };

  tabs() {
    if (this.props.type === I18n.t('select_box')) {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('options'),
            targetName: 'options',
            classes: this.state.active_tab === 'options' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      )
    } else {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      );
    };
  };

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab})
  };

}

